import React from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
const SubscriptionSuccess = () => {
    const history = useHistory()
    return (
        <div className='col-md-12 col-xs-12 col-sm-12 mt-4 brand-left-cntn'>
            <Card className="border-0 p-4" style={{
                borderRadius: '12px',
                backgroundColor: '#f8f9fa',
                borderLeft: '4px solid #165b5b'
            }}>
                {/* Success Header */}
                <div className="text-center mb-4">
                    <i className="bi bi-check-circle-fill mb-3" style={{
                        fontSize: '3rem',
                        color: '#165b5b'
                    }}></i>
                    <h2 style={{ color: '#165b5b', fontWeight: '600' }}>
                        Subscription Successful!
                    </h2>
                    <p className="lead mb-4" style={{ color: '#165b5b' }}>
                        Your brand store is now live
                    </p>
                </div>

                {/* Features Grid */}
                {/* <Row className="g-4 mb-4">
          <Col md={4} className="text-center">
            <div className="p-3 rounded-circle d-inline-block" style={{ 
              backgroundColor: 'rgba(22, 91, 91, 0.1)'
            }}>
              <i className="bi bi-graph-up" style={{
                fontSize: '1.5rem',
                color: '#165b5b'
              }}></i>
            </div>
            <h5 className="mt-3" style={{ color: '#165b5b' }}>Track Performance</h5>
            <p className="text-muted">Monitor your store analytics</p>
          </Col>

          <Col md={4} className="text-center">
            <div className="p-3 rounded-circle d-inline-block" style={{ 
              backgroundColor: 'rgba(22, 91, 91, 0.1)'
            }}>
              <i className="bi bi-gear-fill" style={{
                fontSize: '1.5rem',
                color: '#165b5b'
              }}></i>
            </div>
            <h5 className="mt-3" style={{ color: '#165b5b' }}>Customize Store</h5>
            <p className="text-muted">Personalize your brand</p>
          </Col>

          <Col md={4} className="text-center">
            <div className="p-3 rounded-circle d-inline-block" style={{ 
              backgroundColor: 'rgba(22, 91, 91, 0.1)'
            }}>
              <i className="bi bi-shop" style={{
                fontSize: '1.5rem',
                color: '#165b5b'
              }}></i>
            </div>
            <h5 className="mt-3" style={{ color: '#165b5b' }}>View Storefront</h5>
            <p className="text-muted">See how customers view your store</p>
          </Col>
        </Row> */}

                {/* Action Buttons */}
                <div className="d-flex flex-column flex-md-row justify-content-center gap-3">
                    {/* <Button 
            variant="outline-primary"
            className="d-flex align-items-center justify-content-center"
            style={{ 
              borderColor: '#165b5b',
              color: '#165b5b',
              borderRadius: '8px',
              padding: '0.5rem 1.5rem'
            }}
          >
            Visit Store <i className="bi bi-box-arrow-up-right ms-2"></i>
          </Button> */}
                    <Button
                        variant="primary"
                        className="d-flex align-items-center justify-content-center"
                        style={{
                            backgroundColor: '#165b5b',
                            borderColor: '#165b5b',
                            borderRadius: '8px',
                            padding: '0.5rem 1.5rem'
                        }}
                        onClick={() => history.replace('/my-brands')}
                    >
                        Go to My Brands
                    </Button>
                </div>
            </Card>
        </div>
    );
};

export default SubscriptionSuccess;